/**
 * カスタム表示ラベル
 * 表示用
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/custom_labels`

const search_custom_label = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {

    /**
     * カスタム表示ラベル詳細一覧
     * @return {Promise<unknown>}
     */
    index () {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH).then(data => {
          resolve(data.content)
        })
      })
    },
    // /**
    //  * 運搬ルート詳細一覧(絞り込み条件付き)
    //  * @param commit
    //  * @param without_invisible 非表示を含めない場合はtrue
    //  * @param first_trader_owned 区間1の収運が自社で絞り込む場合はtrue
    //  * @return {Promise<unknown>}
    //  */
    // search ({commit }, { without_invisible, first_trader_owned }) {
    //   const params = {
    //     without_invisible: without_invisible,
    //     first_trader_owned: first_trader_owned,
    //   }
    //   return new Promise((resolve) => {
    //     Vue.$http.get(API_PATH, { params: params }).then(data => {
    //       resolve(data.content)
    //     })
    //   })

    // },
    /**
     * カスタム表示ラベル詳細の取得
     * @param commit
     * @param id
     * @return {Promise<unknown>}
     */
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}
export default search_custom_label
